import React, { ReactNode, useContext, useEffect } from "react";
import { useLocation  } from 'react-router-dom';
import { RootStoreContext } from "../store/rootStore";

interface IProps {
  children: ReactNode;
}

const SetViewType:React.FC<IProps> = ({children}) => {
  const rootStore = useContext(RootStoreContext);
  const {setSubjectType} = rootStore.wallSettingsStore;
  const {clearChosenSubjects} = rootStore.subjectStore;
  const {clearChosenYears} = rootStore.yearsStore;


  const location = useLocation();

  useEffect(() => {
    setSubjectType(location.pathname);
    clearChosenSubjects();
    clearChosenYears();
  }, [location]);

  return (
    <>
      {children}
    </>
  )
};

export default SetViewType;
